import React from 'react'
import { Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { map } from 'lodash';
import { useQuery } from '@apollo/client';
import { GET_SAM2 } from '../../../gql/publication';
import icona from "../../../asets/png/icona.jpg"
import "./Sam.scss";

export default function Samples() {

  const {data, loading  }= useQuery (GET_SAM2)

  if (loading ) return null;

  const {getSample2} = data;

  



  return (
    <div className='publiRow' >
    
    {map(getSample2,(publication,index) => ( 
      <Link key={index} to= {`/Publication/${publication._id}`} className= "publiRow_image">
        <Image src= {publication.file  } size='tiny' 
     />
        <span> {publication.title}</span>
        

      </Link>
    )) }

    </div>
  )
}
